@if (iconNames$ | async; as iconNames) {
  <div class="icons-page">
    <div class="icons-page__header">
      <h1>Unity Icons</h1>
      <input #searchInput placeholder="Search icon ..." type="search" (input)="onIconSearch(searchInput.value)" />
    </div>
    <div class="icons-page__icons">
      @for (iconName of iconNames; track iconName) {
        <div
          class="icons-page__icon"
          container="body"
          role="button"
          tabindex="0"
          [ddsTooltip]="iconName"
          [hidden]="searchIconNameString && !iconName.includes(searchIconNameString)"
          [tooltipShowDelay]="300"
          (click)="onIconClick(iconName)"
          (keydown)="onIconClick(iconName)"
        >
          <div class="icons-page__icon__content">
            <app-icon [color]="'#141414b3'" [icon]="iconName" [size]="24" />
          </div>
        </div>
      }
    </div>
  </div>
}
